<div class="flex flex-col text-white text-xs">

  <div class="flex justify-center">
    <div class="tk-i-etoll-activate mt-3"></div>
  </div>

  <div class="text-center mt-2 mx-6">
    {{'etoll-panel.activate-etoll' | translate}}
    <a href="tel:{{'contact.phone-no-spaces' | translate}}">
      <span class="text-white">{{'contact.phone' | translate}}</span>
    </a>
    <span class="mx-1">{{'labels.or' | translate}}</span>
    <a href="mailto:{{'contact.email' | translate}}?subject={{'etoll-panel.activate-etoll-email-subject' | translate}}">
      <span class="color-blue">{{'contact.email' | translate}}</span>
    </a>
  </div>

  <div class="flex justify-between tk-bg-nero rounded-lg mt-2 py-2 ">
    <span class="ml-5">{{'etoll-panel.subscription-price' | translate}}</span>
    <span class="mr-8">{{'etoll-panel.activation-price' | translate}}</span>
  </div>

</div>
